<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-sm-12 nopads">
    <Transition name="fade">
      <div
        v-if="signs.length > 0"
        class="list-content result-table"
      >
        <vue3-datatable
          ref="resultTable"
          :rows="signs"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          :height="signs.length > 7 ? '36.5em' : '100%'"
          :sortable="true"
          skin="bh-table-compact"
          :has-checkbox="true"
          @row-click="rowClicked"
          @row-select="onRowSelect"
          :row-class="getRowClass"
          cell-class="routa-table-cell"
        >
          <template #empty>
            <div class="text-center my-2">
              {{ $t('area_report.no_results') }}
            </div>
          </template>
          <template #created_at="row">
            {{ getDateString(row.value.created_at) }}
          </template>
          <template #removed_at="row">
            {{ getDateString(row.value.removed_at) }}
          </template>
          <template #sign="row">
            <img
              :src="getImageSource(row.value.sign)"
              height="25px"
              alt=""
              style="margin-right: .5em"
            /> {{ row.value.sign }}
          </template>
          <template #installation="row">
            {{ getInstallationString(row.value.installation) }}
          </template>
          <template #side="row">
            {{ getSideString(row.value.side) }}
          </template>
          <template #material="row">
            {{ getMaterialString(row.value.material) }}
          </template>
          <template #road_name="row">
            {{ getFormattedValue(row.value.road_name) }}
          </template>
          <template #road_num="row">
            {{ getFormattedValue(row.value.road_num) }}
          </template>
          <template #sec_num="row">
            {{ getFormattedValue(row.value.sec_num) }}
          </template>
          <template #sign_condition="row">
            {{ getConditionString(row.value.sign_condition) }}
          </template>
        </vue3-datatable>
      </div>
    </Transition>
  </div>
</template>

<script>

import {timeUtils} from "@/components/mixins/TimeUtils";
import {roadSignHelper} from "@/components/mixins/RoadSignMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'RoadSignList',
    components: {Vue3Datatable},
    mixins: [timeUtils, roadSignHelper, conversionModelHelper],
    props: {
        roadSigns: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'id',
            sortDesc: false,
            selectedRows: [],
            selectedRowId: null,
            signs: [],
        }
    },
    computed: {
        fields() {
            return [
                {field: 'sign', title: this.$t('road_sign.sign'), sort: true, headerClass: 'routa-table-header'},
                {field: 'id', title: this.$t('common.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'contracts_display', title: this.$t('orders.contract'), sort: true, headerClass: 'routa-table-header'},
                {field: 'created_at', title: this.$t('road_sign.created_at'), sort: true, headerClass: 'routa-table-header'},
                {field: 'removed_at', title: this.$t('road_sign.removed_at'), sort: true, headerClass: 'routa-table-header'},
                {field: 'value', title: this.$t('road_sign.value'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'direction', title: this.$t('road_sign.road_direction'), sort: true, headerClass: 'routa-table-header'},
                {field: 'road_name', title: this.$t('road_sign.road_name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'road_num', title: this.$t('road_sign.road_num'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'sec_num', title: this.$t('road_sign.sec_num'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'distance', title: this.$t('road_sign.distance'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'lane', title: this.$t('road_sign.sign_lane'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'installation', title: this.$t('road_sign.installation'), sort: true, headerClass: 'routa-table-header'},
                {field: 'sign_direction', title: this.$t('road_sign.sign_direction'), sort: true, headerClass: 'routa-table-header'},
                {field: 'side', title: this.$t('road_sign.side'), sort: true, headerClass: 'routa-table-header'},
                {field: 'material', title: this.$t('road_sign.material'), sort: true, headerClass: 'routa-table-header'},
                {field: 'sign_condition', title: this.$t('road_sign.condition'), sort: true, headerClass: 'routa-table-header'},
                {field: 'info', title: this.$t('road_sign.info'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        roadSigns() {
            this.signs = []
            let temp = []
            this.roadSigns.forEach(item => {
                let newItem = JSON.parse(JSON.stringify(item))
                newItem.installation = item.installation ? this.getInstallationString(item.installation) : ''

                if (Array.isArray(newItem.contracts) && newItem.contracts.length > 0) {
                    newItem.contracts_display = newItem.contracts
                        .map(c => c && c.name ? c.name : '')
                        .filter(n => n) // remove empty
                        .join(', ')
                } else if(newItem.contract && newItem.contract.name) {
                    newItem.contracts_display = newItem.contract.name
                }
                temp.push(newItem)
            })
            this.$nextTick(() => {
                this.signs = temp
                this.restoreRowsSelection()
            })
        }
    },
    mounted() {
        this.signs = this.roadSigns
    },
    methods: {
        rowClicked: function (details) {
            this.$emit('rowClicked', details)
        },
        getFormattedValue: function (value) {
            if (!value || value < 1) {
                return ""
            }
            return value
        },

        onRowSelect(selectedRows) {
            if (this._syncingSelection) return
            const selectedIds = selectedRows.map(r => r.id)
            const originalItems = this.signs.filter(a => selectedIds.includes(a.id))
            this.selectedRows = originalItems
            this.$emit('row-select', originalItems)
        },

        setSelection(index) {
            this.selectedRowId = null
            if (index >= 0 && index < this.signs.length) {
                this.selectedRowId = this.signs[index].id
            }
        },

        resetSelection() {
            this.selectedRowId = null
            this.selectedIndex = null
            this.$refs.resultTable?.clearSelectedRows()
        },

        applySelection() {
            if (!this.hasCheckbox) return
            this._syncingSelection = true
            this.$nextTick(() => {
                this.selectedIds.forEach(id => {
                    const idx = this.resultList.findIndex(item => item.id === id)
                    if (idx !== -1) {
                        this.$refs.resultTable.selectRow(idx)
                    }
                })
                this._syncingSelection = false
            })
        },

        scrollToSelected() {
            let rowElement
            if (this.selectedRowId) {
                rowElement = document.querySelector(`.row-id-${this.selectedRowId}`)
                if (!rowElement) {
                    // Check if we have something in the index - observation closing case -> need to return to same place in list
                    if (this.selectedIndex && this.selectedIndex >= 0) {
                        this.selectedIndex = Math.min(this.selectedIndex, this.results.length)
                        const scrollId = this.signs[this.selectedIndex].id
                        rowElement = document.querySelector(`.row-id-${scrollId}`)
                    }
                }
            }
            if (rowElement) {
                rowElement.scrollIntoView({ behavior: 'auto', block: 'center' })
            } else {
                this.resetSelection()
            }
        },

        getRowClass(row) {
            return row.id === this.selectedRowId ? 'routa-table-row selected-row row-id-' + row.id : 'routa-table-row  row-id-' + row.id
        },

        restoreRowsSelection() {
            if (this.selectedRows && this.selectedRows.length > 0) {
                this.$nextTick(() => {
                    const indexes = this.selectedRows.map(row => this.signs.findIndex(item => item.id === row.id));
                    indexes.forEach(idx => this.$refs.resultTable.selectRow(idx))
                })
            }
        },

        resetSelectedRows() {
            this.selectedRows = []
        }

    }
}
</script>
